<div class="mb-2">
    <hr class="recordDocumentType" />
    <div class="mt-1 mb-1 resultHeader">
        <div class="iconStyling">
            <img src="../../../../assets/images/PUBSOrange.png"
                alt="{{ 'publicationsIcon' | translate | async }}" 
                attr.aria-label="{{ 'publicationsIcon' | translate | async }}" aria-hidden="true">
            <span class="ml-2">
                <a (click)="openInSameTab()" (dblclick)="openInNewTab()">
                    {{ 'publication.record' | translate | async }}: {{ publicationNumber }}
                </a>
            </span>
        </div>
        <div class="iconStyling recordIcon">
            <img src="../../../../assets/images/record-icon-yellow.png" 
        alt="{{ 'recordIcon' | translate | async }}" 
        attr.aria-label="{{ 'recordIcon' | translate | async }}" aria-hidden="true">
        </div>
    </div>
  
    <div class="resultsCardContainer">
        <div class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold">{{ 'title' | translate | async }}</p>
            <p class="recordValue" innerHTML="{{ title | highlight : this.searchTerms }}">
                {{ title | highlight : this.searchTerms }}
            </p>
        </div>
        <div *ngIf="contributors.length > 0" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold">{{ 'author' | translate | async }}</p>
            <p class="recordValue"
                innerHTML="{{ contributors | commaSeparatedPipe:'contributor' | highlight : this.searchTerms }}">
                {{ contributors | commaSeparatedPipe:'contributor' | highlight : this.searchTerms }}
            </p>
        </div>
        <div class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold">{{ 'publishing.year' | translate | async }}
            </p>
            <p class="recordValue">
                {{ publishingYear }}
            </p>
        </div>
        <div *ngIf="townships.length > 0" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold">{{ 'township.area' | translate | async }}</p>
            <p class="recordValue"
                innerHTML="{{ townships | commaSeparatedPipe:'name' | highlight : this.searchTerms }}">
                {{ townships | commaSeparatedPipe:'name' | highlight : this.searchTerms }}
            </p>
        </div>
        <div *ngIf="nts.length > 0" class="flex mb-0">
            <p class="resultsCardSubtitle font-weight--bold">{{ 'nts' | translate | async }}</p>
            <p class="recordValue" innerHTML="{{ nts | commaSeparatedPipe:'area' | highlight : this.searchTerms  }}">
                {{ nts | commaSeparatedPipe:'area'| highlight : this.searchTerms }}
            </p>
        </div>
    </div>
</div>